import React, { FC } from 'react'
import { OutlinedInput, OutlinedInputProps } from '@mui/material'
import {
  GRAY_COLORS_VARIANTS,
  PRIMARY_COLORS_VARIANTS,
  TEXT_DARK_COLORS_VARIANTS,
} from '@/utils/constants/colors'

export interface DarkInputFieldProps extends OutlinedInputProps {}

export const DarkInputField: FC<DarkInputFieldProps> = ({ sx, ...props }) => {
  return (
    <OutlinedInput
      type="text"
      inputMode="numeric"
      sx={{
        borderRadius: '0.625rem',
        bgcolor: TEXT_DARK_COLORS_VARIANTS[400],
        fontSize: '1.125rem',
        fontWeight: 700,
        color: 'white',
        '& input': { color: 'white' },
        '& .MuiInputAdornment-root .MuiTypography-root': {
          color: GRAY_COLORS_VARIANTS[100],
        },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: PRIMARY_COLORS_VARIANTS[500],
        },
        ...sx,
      }}
      {...props}
    />
  )
}
